import { algorithmExercises } from "~/features/computer/data/exercises/algorithm.exercises";
import { dataAnalyticsExercises } from "~/features/computer/data/da/da.exercises";
import { dsExercises } from "~/features/computer/data/ds/ds.exercises";
import { expressionsExercises } from "~/features/computer/data/exercises/expressions.exercises";
import { verifiedTopicExercises } from "~/features/computer/data/exercises/mcq.units";
import { legalEthicsExercises } from "~/features/computer/data/legal-ethics/legal-ethics.exercises";
import { loopsExercises } from "~/features/computer/data/exercises/loops.exercises";
import { operatorsExercises } from "~/features/computer/data/exercises/operators.exercises";
import { sdlcExercises } from "~/features/computer/data/sdlc/sdlc.exercises";
import { variablesExercises } from "~/features/computer/data/exercises/variables.exercises";

export const useExercises = (topic: "algorithm" | "operators" | "loops" | "variables" | "expressions" | "sdlc" | "data-structures" | "data-analytics" | "emerging-tech" | "legal-ethics" | "digital-literacy" | "entrepreneurship") => {
  return {
    algorithm: verifiedTopicExercises.algorithm ?? algorithmExercises,
    "data-analytics": verifiedTopicExercises["data-analytics"] ?? dataAnalyticsExercises,
    "data-structures": verifiedTopicExercises["data-structures"] ?? dsExercises,
    "digital-literacy": verifiedTopicExercises["digital-literacy"],
    "emerging-tech": verifiedTopicExercises["emerging-tech"],
    entrepreneurship: verifiedTopicExercises.entrepreneurship,
    expressions: expressionsExercises,
    "legal-ethics": verifiedTopicExercises["legal-ethics"] ?? legalEthicsExercises,
    operators: operatorsExercises,
    sdlc: verifiedTopicExercises.sdlc ?? sdlcExercises,
    loops: loopsExercises,
    variables: variablesExercises,
  }[topic];
};
